import { useEffect, useState } from "react";
import { g, api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldCheck, FileText } from "lucide-react";

export const PrivacyCard = () => {
  const [st, setSt] = useState(null);

  useEffect(() => {
    g("/privacy/status")
      .then(setSt)
      .catch(() => {});
  }, []);

  if (!st) return null;

  const apri = async () => {
    const r = await api.get("/tenant/privacy.pdf", { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  };

  return (
    <Card className="p-6" data-testid="privacy-card">
      <div className="flex items-start gap-3">
        <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" />
        <div className="min-w-0">
          <h3 className="font-semibold">Informativa privacy</h3>
          <p className="mt-1 text-sm text-slate-500" data-testid="privacy-card-state">
            {st.accepted
              ? `Accettata il ${new Date(st.accepted_at).toLocaleString("it-IT", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })} da ${st.by} · versione ${st.version}`
              : `Da accettare · versione ${st.version} del ${st.date}`}
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <Button variant="outline" onClick={apri} data-testid="privacy-card-pdf-btn">
              <FileText className="mr-1.5 h-4 w-4" /> Scarica il documento
            </Button>
            <Button asChild variant="ghost">
              <a href="/garanzie" target="_blank" rel="noreferrer" data-testid="privacy-card-garanzie-link">
                Cosa vede e cosa non vede Reprehendo
              </a>
            </Button>
          </div>
          <p className="mt-3 text-xs text-slate-500">
            I tuoi incassi non sono visibili al fornitore: nella pagina «Garanzie» trovi l'elenco completo,
            riga per riga, e il foglio A4 da stampare.
          </p>
        </div>
      </div>
    </Card>
  );
};
